import { Box } from '@atgfr8/atg-ui-tailwind';
import MultiLineTruncate from '@components/Notification/MultiLineTruncate';
import { userStore } from '@store/user';
import { FlagViewModel } from '@typeDefinitions/flagTypes';
import { convertUtcToLocalAndFormat } from '@utils/dateFormat';
import { get, isEmpty } from 'lodash';
import { Accessor, Show } from 'solid-js';

import { notificationClasses as classes } from '../classes';

type PropsT = {
  item: Accessor<FlagViewModel>;
};

export const EscalatedFlagTextContent = (props: PropsT) => {
  return (
    <pre class={classes.noteContainer}>
      <span class="font-bold text-red-600">{props.item().flagType}</span>
      <Show when={props.item().currentState}>
        <br />
        <span class="font-bold">Escalation Reason</span>
        <Box width="8px" style={{ display: 'inline-block' }}>
          <></>
        </Box>
        <span>{props.item().currentState}</span>
      </Show>
      <Show when={props.item().description}>
        <br />
        <MultiLineTruncate text={props.item().description} />
      </Show>
    </pre>
  );
};

export const EscalatedFlagSubTextContent = (props: PropsT) => {
  const displayName = () =>
    !isEmpty(get(props.item(), 'modifiedByName'))
      ? props.item().modifiedByName
      : (props.item().setBy ?? userStore.user.name);

  const displayDate = () =>
    convertUtcToLocalAndFormat(
      (props.item().modifiedDate ?? props.item().setDate) as string,
      'MM/dd/yyyy h:mm a',
    );

  return (
    <div class="text-red-800">
      {displayName()} {displayDate()}
    </div>
  );
};
